import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";
import { ReactComponent as Chat } from "../../Global Icons/chat&support.svg";
import { useDispatch, useSelector } from "react-redux";
import { getChatListPaymentExec } from "../../Redux/Actions/chatAction";

const ChatList = ({ setSelectedBookingId }) => {
  // eslint-disable-next-line no-unused-vars
  const [messages, setMessages] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedBooking, setSelectedBooking] = useState(null);
  

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, limit) => {
    const chatData = {
      page,
      limit,
    };
    dispatch(getChatListPaymentExec(chatData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { chats } = useSelector((state) => state.chats || {});

  useEffect(() => {
    if (chats?.total) {
      setPagination((prevData) => ({ ...prevData, total: chats.total }));
    }
  }, [chats]);

  // const handleScrollChange = (pagination) => {
  //   setPagination(pagination);
  //   fetchDetails(pagination.current, pagination.pageSize);
  // };


  const handleChatClick = (booking_id) => {
    setSelectedBookingId(booking_id);
    setSelectedBooking(booking_id);
    setMessages([]);
  };

  return (
    <div>
      <div>
        <div className="chat_left_panel">
          <div className="chat_left_panel_icon">
            <Chat style={{ height: "40px", width: "40px" }}></Chat>
            <h1>Chats</h1>
          </div>
         
          <hr />
          <div>
            <TextInput placeholder="Search Bar"></TextInput>
          </div>
          <hr />
          {Array.isArray(chats?.data)
            ? chats.data.map((chat, index) => (
                <div
                  className="individual_chat"
                  key={index}
                  onClick={() => handleChatClick(chat.booking_id)}
                >
                  <img
                    src={
                      chat?.image
                        ? chat.image
                        : require("../../Global Icons/AlternateImage.png")
                    }
                    alt=""
                  />
                  <div>
                    <h2>{chat.name}</h2>
                    <h4>{chat.last_message}</h4>
                  </div>
                </div>
              ))
            : []}
        </div>
      </div>
    </div>
  );
};

export default ChatList;
